import { ERFElement } from '../enums';
export const RFElementWidth = {
    [ERFElement.Element]: 180,
    [ERFElement.Recycle]: 36,
    [ERFElement.Function]: 60,
    [ERFElement.Optimization]: 60,
    [ERFElement.GroupDashed]: 0,
    [ERFElement.DotEnergy]: 14,
    [ERFElement.DotMaterial]: 14,
    [ERFElement.Absorber]: 140,
    [ERFElement.FlowMaterial]: 34,
    [ERFElement.FlowEnergy]: 34,
    [ERFElement.Separator2ph]: 50,
    [ERFElement.Separator3ph]: 120,
    [ERFElement.CatCracking]: 172,
    [ERFElement.CatCrackingRRBlock]: 69,
    [ERFElement.CatReforming]: 190,
    [ERFElement.CatReformingRRBlock]: 160,
    [ERFElement.Coker]: 172,
    [ERFElement.CokerRBlock]: 172,
    [ERFElement.DieselFuelHydrotreating]: 170,
    [ERFElement.DieselFuelHydrotreatingRBlock]: 170,
    [ERFElement.DistillationColumnRC]: 190,
    [ERFElement.Compressor]: 70,
    [ERFElement.HeatExchanger]: 60,
    [ERFElement.Heater]: 60,
    [ERFElement.Cooler]: 60,
    [ERFElement.Valve]: 56,
    [ERFElement.Fractionator]: 124,
    [ERFElement.Mixer]: 56,
    [ERFElement.ComponentSplitter]: 56,
    [ERFElement.Splitter]: 56,
    [ERFElement.Detander]: 56,
    [ERFElement.Pump]: 60,
    [ERFElement.Pipeline]: 90,
    [ERFElement.HeatExchangerSynthetic]: 56,
    [ERFElement.MultiStepCoherent]: 56,
    [ERFElement.MultiStepExternal]: 56,
    [ERFElement.Balancer]: 56,
    [ERFElement.EngineTestSynthetic]: 56
};
//# sourceMappingURL=rfSize.constants.js.map